export var E_Product;
(function (E_Product) {
    // 默认都有
    E_Product["Passport"] = "Passport";
    E_Product["Analytics"] = "Analytics";
    E_Product["Insights"] = "Insights";
    E_Product["Chemical"] = "Chemical";
    E_Product["Bio"] = "Bio";
    E_Product["IPManagement"] = "IPManagement";
    E_Product["ToBCourse"] = "ToBCourse";
    E_Product["Discovery"] = "Discovery";
})(E_Product || (E_Product = {}));
// 全局事件总线 事件名称
export var E_BusEventName;
(function (E_BusEventName) {
    E_BusEventName["UPDATE_COMPANYINFO"] = "updateCompanyInfo";
    E_BusEventName["ADD_PRIVILEGE_SUCCESS"] = "addPrivilegeSuccess";
    E_BusEventName["BULK_ASSIGN"] = "bulkAssign";
})(E_BusEventName || (E_BusEventName = {}));
export const ProductNameEProductMap = {
    chemical: E_Product.Chemical,
    bio: E_Product.Bio,
    pro: E_Product.Analytics,
    report: E_Product.Insights,
    innosnap: E_Product.IPManagement,
    course2b: E_Product.ToBCourse,
    discovery: E_Product.Discovery,
    patsnap360: E_Product.Discovery,
};
// 通用货币
export var E_Currency;
(function (E_Currency) {
    /**
     * 人民币
     */
    E_Currency["CNY"] = "cny";
    /**
     * 美元
     */
    E_Currency["USD"] = "usd";
    /**
     * 欧元
     */
    E_Currency["EUR"] = "eur";
    /**
     * 英镑
     */
    E_Currency["GBP"] = "gbp";
    /**
     * 日元
     */
    E_Currency["JPY"] = "jpy";
})(E_Currency || (E_Currency = {}));
export const onSaleProductMapList = [
    {
        product: 'Analytics',
        product_id: 'pro',
    },
    {
        product: 'Chemical',
        product_id: 'chemical',
    },
    {
        product: 'Bio',
        product_id: '563398857b284d14a48575e06990b9e4',
    },
    // {
    //     product: 'Eureka',
    //     product_id: 'bae91377ed7b45209cd48e076392cbbb', // 研发情报库
    // },
    {
        product: 'Synapse',
        product_id: '895f1015a21741bb97019a928c2c578b',
    },
    {
        product: 'Discovery',
        product_id: 'a2f4c064c228430a84f6087b5f870487',
    },
    {
        product: 'TFFI',
        product_id: '974ff55f8941429fa7d7f81bd1a42023',
    }
];
